import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { QuoteProvider } from "@/context/QuoteCart";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import QuoteBar from "@/components/QuoteBar";
import StickyCta from "@/components/StickyCta";
import CookieConsent from "@/components/CookieConsent";
import StructuredData from "@/components/StructuredData";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import Colors from "@/pages/Colors";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Kvkk from "@/pages/Kvkk";
import Cookies from "@/pages/Cookies";
import ThankYou from "@/pages/ThankYou";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <QuoteProvider>
        <BrowserRouter>
          <StructuredData />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/urunler" element={<Products />} />
            <Route path="/renkler" element={<Colors />} />
            <Route path="/hakkimizda" element={<About />} />
            <Route path="/iletisim" element={<Contact />} />
            <Route path="/gizlilik" element={<Privacy />} />
            <Route path="/kvkk-aydinlatma-metni" element={<Kvkk />} />
            <Route path="/cerez-politikasi" element={<Cookies />} />
            <Route path="/tesekkurler" element={<ThankYou />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Footer />
          <QuoteBar />
          <StickyCta />
          <CookieConsent />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </QuoteProvider>
    </div>
  );
}

export default App;
